import { render } from "./DashboardEtman.vue?vue&type=template&id=57198de7&scoped=true"
import script from "./DashboardEtman.vue?vue&type=script&lang=js"
export * from "./DashboardEtman.vue?vue&type=script&lang=js"

import "./DashboardEtman.vue?vue&type=style&index=0&id=57198de7&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57198de7"]])

export default __exports__